<template lang="pug">
v-container.px-10(fluid grid-list-lg)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )

  v-card.px-4(style="overflow:hidden")
    v-card-title(primary-title)
      v-row(v-if="!loading" wrap)
        v-col(cols="12", md="6")
          h2.primary--text {{ $t('User.information')}}
    v-container.pt-0(fluid)
      v-row(v-if="!loading" wrap)
        v-col(cols="3", xs="12")
          v-text-field(
            v-model="instance.name",
            :label="$t('User.name')",
            :error-messages="errors['user.name']",
            :error="!!errors['user.name']"
            )
        v-col(cols="3", xs="12")
          v-text-field(
            v-model="instance.lastName",
            :label="$t('User.lastName')",
            :error-messages="errors['user.lastName']",
            :error="!!errors['user.lastName']"
            )
        v-col(cols="3", xs="12")
          v-text-field(
            v-model="instance.email",
            :label="$t('User.email')",
            :error-messages="errors['user.email']",
            :error="!!errors['user.email']"
            )
        v-col(cols="3", xs="12")
          v-text-field(
            v-model="instance.phoneNumber",
             :label="$t('User.phoneNumber')",
            :error-messages="errors['user.phoneNumber']",
            :error="!!errors['user.phoneNumber']"
            )
      v-row(v-if="!loading" wrap)
        v-col(cols="4", xs="12")
          app-datetime-picker(
            :value="instance.createdAt",
            :label="$t('User.createdAt')",
            disabled,
          )
        v-col(cols="4", xs="12")
          app-datetime-picker(
            :value="instance.modifiedAt",
            :label="$t('User.modifiedAt')",
            disabled,
          )
        v-col(cols="4", xs="12")
          v-text-field(
            :label="$t('User.createdBy')",
            :value="(instance.createdBy || {}).fullName"
            disabled,
          )
    v-card-title(primary-title)
      v-row(v-if="!loading" wrap)
        v-col(cols="12", md="6")
          h2.primary--text {{$t('User.cityAndTimezone')}}
    v-container.pt-0(fluid)
      v-row(v-if="!loading" wrap)
        v-col(cols="3")
          v-text-field(
            v-model="instance.cityName",
            :label="$t('User.city')",
            :error-messages="errors['user.cityName']",
            :error="!!errors['user.cityName']",
            )
        v-col(cols="3")
          v-text-field(
            v-model="instance.stateName",
            :label="$t('User.state')",
            :error-messages="errors['user.stateName']",
            :error="!!errors['user.stateName']",
            )
        v-col(cols="3")
          v-text-field(
            v-model="instance.countryName",
            :label="$t('User.country')",
            :error-messages="errors['user.countryName']",
            :error="!!errors['user.countryName']",
            )
        v-col(cols="3")
          v-autocomplete(
            v-model="instance.timeZone",
            :items='TimeZones'
            :error-messages="errors['user.timeZone']",
            item-text='displayName'
            item-value='idName'
            :label="$t('User.timezone')",
            :loading="loadingLists"
            )
              template(v-slot:append)
                v-icon(color="primary") mdi-menu-down
    v-card-title(primary-title)
      v-row(v-if="!loading" wrap)
        v-col(cols="12", md="6")
          h2.primary--text {{ $t('User.accessManagement') }}
    v-container.pt-0(fluid)
      v-row(v-if="!loading" wrap)
        v-col(cols="12")
          p.mb-0.v-messages__message(v-for="e in errors['user.userRoleBusinessScopes']", style="color:red") {{ e }}
          //- user-group-role(v-model="instance.userRoleBusinessScopes", :error-messages="errors['user.permissions']", :groups="allGroups", :roles="allRoles", :partyGroups="allPartyGroups" :instance="instance")
          user-group-role(v-model="userGroups", :error-messages="errors['user.permissions']", :groups="allGroups", :roles="allRoles", :partyGroups="allPartyGroups", :taskGroups="allTaskGroups", :instance="instance", :loading="loadingLists",)
        v-col(cols="3")
          v-text-field(
            :value="instance.defaultBusinessScope && instance.defaultBusinessScope.path",
            :label="$t('User.defaultBusinessScope')",
            disabled,
            :error-messages="errors['user.defaultBusinessScope']",
            :error="!!errors['user.defaultBusinessScope']",
            :loading="loadingLists",
          )

  v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
    v-col.py-0.text-right
      g-btn.mr-2.px-6(color="red", @click="cancel", :disabled="loading", outlined) {{ $t('Common.cancel') }}
      g-btn.ml-2.success.px-8(@click="save", :disabled="loading") {{ $t('Common.save') }}
  p.v-messages__message(v-if="instance.deletedAt != null", style="color:white") {{$t('User.deleted')}}
</template>

<style scoped>
  .v-input__append-inner .v-input__icon--append .v-icon {
    color: blue important;
  }
</style>

<script>
import axios from 'axios'

export default {
  name: 'AddUser',
  data: function () {
    return {
      loading: true,
      instance: {},
      TimeZones: [],
      errors: {},
      errorsGroup: [],
      errorsRole: [],

      allGroups: [],
      allRoles: [],
      allPartyGroups: [],
      allTaskGroups: [],
      userGroups: [],
      loadingLists: true,
    }
  },

  computed: {
    entityName () {
      return 'User'
    },
    entity () {
      return this.$findEntity('User')
    },
    uid () {
      return this.$route.params.item
    },
    isDataComplete: function () {
      return true;
    },
    isSaveable: function () {
       return !this.loading && this.isDataComplete;
    },
  },

  watch: {
  },

  methods: {
    initInstance () {
      return {
        _Entity: this.entity.name,
        ...this.instance,
        entityState: this.instance && this.instance.id
          ? ENV.ENTITY.STATE.UNCHANGED
          : ENV.ENTITY.STATE.ADDED,
        createdBy: this.instance && this.instance.id
          ? this.instance.createdBy
          : this.$store.state.user.user
      }
    },
    async save () {
      //Reset instance lists
      this.instance.userRoleBusinessScopes = []
      this.instance.groupPartyUsers = []
      this.instance.groupTaskUsers = []
      //Add the group entities to the instance
      for(let i in this.userGroups) {
        //Map from [userGroups.uRoleBS] to [instance.userRoleBusinessScopes]
        this.instance.userRoleBusinessScopes.push(this.userGroups[i].uRoleBS);
        //Map from [userGroups.partyGroup] to [instance.groupEntities]
        if(this.userGroups[i].partyGroup != null) this.instance.groupPartyUsers.push(this.userGroups[i].partyGroup);
        if(this.userGroups[i].taskGroup != null) this.instance.groupTaskUsers.push(this.userGroups[i].taskGroup);
      }

      this.loading = true
      if(this.IsAddedOrHasBSRoleIfUpdate()) {
        try {
          //Remove Soft deleted when save
          this.instance.deletedAt = null;
          //If edit related entities to User, but not the User entity root, set entityState = 3 in order to update de user (remove softdeleted)
          if(this.instance.entityState == 1) this.instance.entityState = 3;
          this.instance = (await axios.post('entity/graph', this.instance)).data;
          this.$router.push({
            name: 'entities.index',
            params: { entity: this.entity.name }
          })
        } catch (error) {
          this.errors = error.response.data.errors
        } finally {
          this.loading = false
        }
      } else {
        this.errors['user.userRoleBusinessScopes'] = ["At least one Role - Business Scope has to be assigned"]
        this.loading = false
      }
    },
    cancel () {
      this.$router.go(-1);
    },
    // Check if the user will be updated, at least he has one role - business scope
    IsAddedOrHasBSRoleIfUpdate() {
      this.errors['user.userRoleBusinessScopes'] = []
      if(this.instance.entityState != 3) return true;
      if(this.instance.userRoleBusinessScopes.filter(x => x.entityState != 2 && x.deletedAt == null).length > 0) return true;
      return false;
    },
    async load () {
      try {
        if (this.uid) {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, 'ExtraData', 'UserRoleBusinessScopes', 'GroupPartyUsers.Group', 'GroupPartyUsers.Group.GroupParties','GroupTaskUsers.Group', 'GroupTaskUsers.Group.GroupTasks', 'CreatedBy')
          this.instance = (await axios.get(endpoint, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data;

          this.userGroups = [];
          for(let index in this.instance.userRoleBusinessScopes){
            const pg = _.chain(this.instance.groupPartyUsers)
                        .find(g => g.businessScopeId === this.instance.userRoleBusinessScopes[index].businessScopeId)
                        .value();

            const tg = _.chain(this.instance.groupTaskUsers)
                        .find(g => g.businessScopeId === this.instance.userRoleBusinessScopes[index].businessScopeId)
                        .value();
            let accessObject = { uRoleBS: this.instance.userRoleBusinessScopes[index], partyGroup: pg };
            if (tg)
              accessObject.taskGroup = tg;
            this.userGroups.push(accessObject);
          }
        }
      } catch (error) {
          // console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async loadLists() {
      try {
        const newinstance = axios.create({  baseURL: process.env.VUE_APP_API_ENDPOINT, timeout: 2000, headers: {'X-Custom-Header': 'foobar'}});
        this.newinstance = await newinstance.get(`TimeZones`, { params: { pageSize: -1 }});
        this.TimeZones = this.newinstance.data.data;

        ({ data: { data: this.allGroups } } = await axios.get('BusinessScopes', { params: { pageSize: -1 } }));
        ({ data: { data: this.allRoles } } = await axios.get('Role', { params: { pageSize: -1 } }));
        ({ data: { data: this.allPartyGroups } } = await axios.get('GroupParty', {params: { pageSize: -1 } } ));
        ({ data: { data: this.allTaskGroups } } = await axios.get('GroupTask', {params: { pageSize: -1 } } ));
      } catch (e) {
        console.log(this.$cleanString(e));
      } finally {
        this.loadingLists = false;
      }
    },
  },
  async created () {
    await this.load();
    this.instance = this.initInstance();
    await this.loadLists();
    this.$watch('instance', {
      deep: true,
      handler(instance) {
        if(instance && instance.id && (instance.entityState != ENV.ENTITY.STATE.MODIFIED)) instance.entityState = ENV.ENTITY.STATE.MODIFIED;
      },
    });
  },
}

</script>
